export const getButtonClassName = (type: string, layers: any) => {
  const className = "Warstwy_button--" + type;
  const isButtonHidden = layers.some(
    (layer: any) =>
      (type === "show" && !layer.isVisible) ||
      (type === "hide" && layer.isVisible)
  );
  if (isButtonHidden) return className + "Hidden";
  return className;
};
